/**
 * @generated SignedSource<<ef941697ebefc8059a6e2b804718fa9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InfoBoxSubscription$variables = {
  screenId: string;
};
export type InfoBoxSubscription$data = {
  readonly storecastScreenInfoChange: {
    readonly " $fragmentSpreads": FragmentRefs<"InfoBox_StorecastScreen">;
  } | null;
};
export type InfoBoxSubscription = {
  response: InfoBoxSubscription$data;
  variables: InfoBoxSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "screenId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "screenId",
    "variableName": "screenId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InfoBoxSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "storecastScreenInfoChange",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InfoBox_StorecastScreen"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InfoBoxSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "storecastScreenInfoChange",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StorecastDeviceInfo",
            "kind": "LinkedField",
            "name": "info",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "language",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "languageStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resolution",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resolutionStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "time",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeZone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeZoneStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userAgentStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3c3ef208e0ebdecff37f0bdc433c3a43",
    "id": null,
    "metadata": {},
    "name": "InfoBoxSubscription",
    "operationKind": "subscription",
    "text": "subscription InfoBoxSubscription(\n  $screenId: ID!\n) {\n  storecastScreenInfoChange(screenId: $screenId) {\n    ...InfoBox_StorecastScreen\n    id\n  }\n}\n\nfragment InfoBox_StorecastScreen on StorecastScreen {\n  id\n  info {\n    language\n    languageStatus\n    resolution\n    resolutionStatus\n    time\n    timeStatus\n    timeZone\n    timeZoneStatus\n    userAgentStatus\n  }\n}\n"
  }
};
})();

(node as any).hash = "821c81f97816e5d9a31a4ffd73f9f42b";

export default node;
